import React, { useState, useEffect,useContext } from 'react';
import {
    Divider,
    Row,
    Table,
    Modal,
    Button,
    Form,
    DatePicker,
    Space,
    Select,
    Input,
    Col,
    Menu,
    Typography
} from "antd";
import moment from 'moment';
import 'antd/dist/antd.css';
import { DownloadOutlined,SearchOutlined } from '@ant-design/icons';
import { onGetTasksByDate } from '../../Controller/Management/TaskManagement';
import { getAllUserLists } from '../../Controller/Management/UserProf_Ctrl';
import AppContext from "../AppContext"

import Highlighter from 'react-highlight-words';



export default function TaskReport(prop) {
    const dateFormat = 'YYYY/MM/DD';
    const filstyle = { padding: '8px 0' };
    const global                            = useContext(AppContext)
    const userid                            = global.UserIdentity.userid;
    const [resulttabletitle, setresulttabletitle] = useState()
    const [pendingresulttabletitle, setpendingresulttabletitle] = useState()
    const [finalresult, setfinalresult] = useState([])
    const [pendingresult, setpendingresult] = useState([])
    const [userLists, setuserLists] = useState([])
    const [dateRange, setDateRange] = useState(
        {
            from: moment(new Date(), dateFormat).startOf('month'),
            to: moment(new Date(), dateFormat).endOf('month')
        }
    )
    function padTo2Digits(num) {
        return num.toString().padStart(2, '0');
      }
      
      function formatDate(date) {
        return (
          [
            date.getFullYear(),
            padTo2Digits(date.getMonth() + 1),
            padTo2Digits(date.getDate()),
          ].join('-') +
          ' ' +
          [
            padTo2Digits(date.getHours()),
            padTo2Digits(date.getMinutes()),
            padTo2Digits(date.getSeconds()),
          ].join(':')
        );
      }
      function formatDateDigit(date) {
        return (
          [
            date.getFullYear(),
            padTo2Digits(date.getMonth() + 1),
            padTo2Digits(date.getDate()),
          ].join('-') 
          
          
        );
      }

    var summarytable = 
    [
        {
            title: <div>CS/Tech</div>,
            dataIndex: 'assignto',
            key: 'assignto',
                
        },
        {
            title: <div>Task</div>,
            dataIndex: 'task',
            key: 'task',
            align:'right',
        }, 
        {
            title: <div>Complete In Time</div>,
            dataIndex: 'complete',
            key: 'complete',
            align:'right',
        }, 
        {
            title: <div>Delay</div>,
            dataIndex: 'delay',
            key: 'delay',
            align:'right',
        }, 
        {
            title: <div>In Progress</div>,
            dataIndex: 'inProgress',
            key: 'inProgress',
            align:'right',
           
        }, 
        
        {
            title: <div>Overdue</div>,
            dataIndex: 'overdue',
            key: 'overdue',
            align:'right',
           
        }, 

    ]
  
    var summarypendingtable = 
    [
        {
            title: <div>CS/Tech</div>,
            dataIndex: 'assignto',
            key: 'assignto',
                
        },
        {
            title: <div>Task</div>,
            dataIndex: 'task',
            key: 'task',
            align:'right',
        }, 
        {
            title: <div>In Progress</div>,
            dataIndex: 'inProgress',
            key: 'inProgress',
            align:'right',
           
        }, 
        
        {
            title: <div>Overdue</div>,
            dataIndex: 'overdue',
            key: 'overdue',
            align:'right',
           
        }, 

    ]
  
    var detailtable =
    [
        {
            title: <div>Task Name</div>,
            dataIndex: 'taskname',
            key: 'taskname',
                
        },
        {
            title: <div>Description</div>,
            dataIndex: 'description',
            key: 'description',
                
        },
        {
            title: <div>Create Date</div>,
            dataIndex: 'createdte',
            key: 'createdte',
                
        },
        {
            title: <div>Deadline</div>,
            dataIndex: 'deadline',
            key: 'deadline',
                
        },
        {
            title: <div>Complete Date</div>,
            dataIndex: 'completedate',
            key: 'completedate',
                
        },
       
    ]

    var detailpendingtable =
    [
        {
            title: <div>Task Name</div>,
            dataIndex: 'taskname',
            key: 'taskname',
                
        },
        {
            title: <div>Description</div>,
            dataIndex: 'description',
            key: 'description',
                
        },
        {
            title: <div>Create Date</div>,
            dataIndex: 'createdte',
            key: 'createdte',
                
        },
        {
            title: <div>Deadline</div>,
            dataIndex: 'deadline',
            key: 'deadline',
                
        },
       
    ]


    async function doGetTaskAPI() {

     var sdatetemp =moment(dateRange.from, dateFormat).startOf('day').unix()
     var edatetemp =moment(dateRange.to, dateFormat).startOf('day').unix()
     
     //sdatetemp ="1646092800"
     //edatetemp ="1648684800"
  
       const result = await onGetTasksByDate( {task_starttime:sdatetemp.toString().trim(),task_endtime: edatetemp.toString().trim(),reportto:userid })
       const userresult = await getAllUserLists({})
      
       //console.log("result",result.data)
       if(result.data != undefined)
       {
        const afterbuildresult = buildResult(result.data,userresult.data)
        const pendingresult = buildPendingResult(result.data,userresult.data)
        setfinalresult(afterbuildresult)
        setpendingresult(pendingresult)
        setresulttabletitle("Task Listing " + moment(dateRange.from).format("MM/YYYY"))
        setpendingresulttabletitle("Previous Pending List before "+moment(dateRange.from).format("MM/YYYY"))
       
        //console.log("afterbuildresult",afterbuildresult)
        //console.log("pendingresult",pendingresult)
    
       }
      

      }

    function buildResult(xData,userLists) {
        var newlist = [];
        var obj = {};
        var detaillist = []
        var detailobject = {}
        var count=0
        var currentTECH = ""
        var taskcount =0
        var completeintime = 0
        var delay =0
        var inProgress = 0
        var overdue = 0
        var firstrecord =0
        var key=0
        
        xData.forEach(function (items) { 

            
            var checksdate = moment(dateRange.from, dateFormat).startOf('day').unix()
            var checkedate = moment(dateRange.to, dateFormat).startOf('day').unix()

            if(items.createdte >= checksdate && items.createdte <= checkedate)
            {
                if (currentTECH != items.assignto.toString().trim())
                {
                    if(firstrecord ==1)
                    {
                        key+=1
                        obj["key"] = key
                        newlist.push(obj);
    
                        taskcount =0
                        completeintime = 0
                        delay =0
                        inProgress = 0
                        overdue = 0
                        currentTECH =""
                        obj = {}
                        detaillist = []
                        
                        
                    }
                }
                if(currentTECH == "")
                {
                    firstrecord =1
                    if(items.assignto.toString().trim() == "")
                    {
                        obj["assignto"] = "Open Task"
                        currentTECH = "Open Task"
                    }
                    else
                    {
                        
                        let tempuserid = userLists.filter(x => x._id == items.assignto.toString().trim())

                        if(tempuserid.length > 0)
                        {
                            tempuserid = tempuserid[0].userid
                        }
                        else
                        {
                            tempuserid = items.assignto.toString().trim()
                        }
                     
                        obj["assignto"] = tempuserid
                        currentTECH = items.assignto.toString().trim()
                    }     
                    taskcount+=1
                    obj["task"] = taskcount
                    
                    if(items.status.toString().trim() == "0")
                    {
                        if(items.deadline.toString().trim() == "")
                        {
                            inProgress +=1
                            obj["inProgress"] =inProgress
                        }
                        else
                        {
                            var minutesdiff =  moment().diff(moment.unix(items.deadline), 'minutes');
                            if(minutesdiff > 0)
                            {
                                overdue +=1
                                obj["overdue"] = overdue
                            }
                            else
                            {
                                inProgress +=1
                                obj["inProgress"] =inProgress 
                            }
                        }
                       
                    }
                    else if (items.status.toString().trim() == "3")
                    {
                        if(items.deadline.toString().trim() == "")
                        {
                            completeintime +=1
                            obj["complete"] =completeintime
                        }
                        else
                        {
                            var minutesdiff =  moment().diff(moment.unix(items.deadline), 'minutes');
                            if(minutesdiff > 0)
                            {
                                delay +=1
                                obj["delay"] = delay
                            }
                            else
                            {
                                completeintime +=1
                                obj["complete"] =completeintime 
                            }
                        }
                       
                       
                    }
                    
                }
                else if(currentTECH == items.assignto.toString().trim())
                {
                    firstrecord =1
                    if(items.assignto.toString().trim() == "")
                    {
                        obj["assignto"] = "Open Task"
                        currentTECH = "Open Task"
                    }
                    else
                    {
                        let tempuserid = userLists.filter(x => x._id == items.assignto.toString().trim())

                        if(tempuserid.length > 0)
                        {
                            tempuserid = tempuserid[0].userid
                        }
                        else
                        {
                            tempuserid = items.assignto.toString().trim()
                        }

                        obj["assignto"] = tempuserid
                        currentTECH = items.assignto.toString().trim()
                    }     
                    taskcount+=1
                    obj["task"] = taskcount
                    
                    if(items.status.toString().trim() == "0")
                    {
                        if(items.deadline.toString().trim() == "")
                        {
                            inProgress +=1
                            obj["inProgress"] =inProgress
                        }
                        else
                        {
                            var minutesdiff =  moment().diff(moment.unix(items.deadline), 'minutes');
                            if(minutesdiff > 0)
                            {
                                overdue +=1
                                obj["overdue"] = overdue
                            }
                            else
                            {
                                inProgress +=1
                                obj["inProgress"] =inProgress 
                            }
                        }
                       
                    }
                    else if (items.status.toString().trim() == "3")
                    {
                        if(items.deadline.toString().trim() == "")
                        {
                            completeintime +=1
                            obj["complete"] =completeintime
                        }
                        else
                        {
                            var minutesdiff =  moment().diff(moment.unix(items.deadline), 'minutes');
                            if(minutesdiff > 0)
                            {
                                delay +=1
                                obj["delay"] = delay
                            }
                            else
                            {
                                completeintime +=1
                                obj["complete"] =completeintime 
                            }
                        }
                       
                       
                    }
                    
                }
    
                detailobject["taskname"] = items.taskname.toString().trim()
                detailobject["description"] = items.description.toString().trim()
                
                var myDate = new Date( items.createdte *1000);
                var myDate1 = ""
                var myDate2 = ""
                if(items.deadline != "")
                {
                    myDate1 = new Date( items.deadline *1000);
                    detailobject["deadline"] = formatDateDigit(myDate1)
                }
                else
                {
                    myDate1 = ""
                    detailobject["deadline"] = ""
                }
    
                if(items.completedate != undefined)
                {
                    myDate2 = new Date( items.completedate *1000);
                    detailobject["completedate"] = formatDateDigit(myDate2)
                }
                else
                {
                    myDate2 = ""
                    detailobject["completedate"] = ""
                }
                
                var myDate2 = new Date( items.completedate *1000);
                detailobject["createdte"] = formatDateDigit(myDate)
    
                
                detaillist.push(detailobject)
                obj["detaillist"] = detaillist
                detailobject={}
                
                
              
               if(count == xData.length)
               {
                   newlist.push(obj)
               }
            
    
            }
            count++
            if(count == xData.length)
            {
                newlist.push(obj)
            }
      
        });
        
        return newlist;
    }

    function buildPendingResult(xData,userLists) {
        var newlist = [];
        var obj = {};
        var detaillist = []
        var detailobject = {}
        var count=0
        var currentTECH = ""
        var taskcount =0
        var completeintime = 0
        var delay =0
        var inProgress = 0
        var overdue = 0
        var firstrecord =0
        var key=0
        
        xData.forEach(function (items) { 

            
            var checksdate = moment(dateRange.from, dateFormat).startOf('day').unix()
            var checkedate = moment(dateRange.to, dateFormat).startOf('day').unix()

            if(items.createdte < checksdate)
            {
                if (currentTECH != items.assignto.toString().trim())
                {
                    if(firstrecord ==1)
                    {
                        key+=1
                        obj["key"] = key
                        newlist.push(obj);
    
                        taskcount =0
                        completeintime = 0
                        delay =0
                        inProgress = 0
                        overdue = 0
                        currentTECH =""
                        obj = {}
                        detaillist = []
                        
                        
                    }
                }
                if(currentTECH == "")
                {
                    firstrecord =1
                    if(items.assignto == "")
                    {
                        obj["assignto"] = "Open Task"
                        currentTECH = "Open Task"
                    }
                    else
                    {

                        let tempuserid = userLists.filter(x => x._id == items.assignto.toString().trim())

                        if(tempuserid.length > 0)
                        {
                            tempuserid = tempuserid[0].userid
                        }
                        else
                        {
                            tempuserid = items.assignto.toString().trim()
                        }

                        obj["assignto"] = tempuserid
                        currentTECH = items.assignto.toString().trim()
                    }     
                    taskcount+=1
                    obj["task"] = taskcount
                    
                    if(items.status == "0")
                    {
                        if(items.deadline == "")
                        {
                            inProgress +=1
                            obj["inProgress"] =inProgress
                        }
                        else
                        {
                            var minutesdiff =  moment().diff(moment.unix(items.deadline), 'minutes');
                            if(minutesdiff > 0)
                            {
                                overdue +=1
                                obj["overdue"] = overdue
                            }
                            else
                            {
                                inProgress +=1
                                obj["inProgress"] =inProgress 
                            }
                        }
                       
                    }
                    else if (items.status == "3")
                    {
                        if(items.deadline == "")
                        {
                            completeintime +=1
                            obj["complete"] =completeintime
                        }
                        else
                        {
                            var minutesdiff =  moment().diff(moment.unix(items.deadline), 'minutes');
                            if(minutesdiff > 0)
                            {
                                delay +=1
                                obj["delay"] = delay
                            }
                            else
                            {
                                completeintime +=1
                                obj["complete"] =completeintime 
                            }
                        }
                       
                       
                    }
                    
                }
                else if(currentTECH == items.assignto)
                {
                    firstrecord =1
                    if(items.assignto== "")
                    {
                        obj["assignto"] = "Open Task"
                        currentTECH = "Open Task"
                    }
                    else
                    {
                        let tempuserid = userLists.filter(x => x._id == items.assignto.toString().trim())

                        if(tempuserid.length > 0)
                        {
                            tempuserid = tempuserid[0].userid
                        }
                        else
                        {
                            tempuserid = items.assignto.toString().trim()
                        }
                        obj["assignto"] = tempuserid
                        currentTECH = items.assignto
                    }     
                    taskcount+=1
                    obj["task"] = taskcount
                    
                    if(items.status == "0")
                    {
                        if(items.deadline == "")
                        {
                            inProgress +=1
                            obj["inProgress"] =inProgress
                        }
                        else
                        {
                            var minutesdiff =  moment().diff(moment.unix(items.deadline), 'minutes');
                            if(minutesdiff > 0)
                            {
                                overdue +=1
                                obj["overdue"] = overdue
                            }
                            else
                            {
                                inProgress +=1
                                obj["inProgress"] =inProgress 
                            }
                        }
                       
                    }
                    else if (items.status == "3")
                    {
                        if(items.deadline == "")
                        {
                            completeintime +=1
                            obj["complete"] =completeintime
                        }
                        else
                        {
                            var minutesdiff =  moment().diff(moment.unix(items.deadline), 'minutes');
                            if(minutesdiff > 0)
                            {
                                delay +=1
                                obj["delay"] = delay
                            }
                            else
                            {
                                completeintime +=1
                                obj["complete"] =completeintime 
                            }
                        }
                       
                       
                    }
                    
                }
    
                detailobject["taskname"] = items.taskname.toString().trim()
                detailobject["description"] = items.description.toString().trim()
                
                var myDate = new Date( items.createdte *1000);
                var myDate1 = ""
                var myDate2 = ""
                if(items.deadline != "")
                {
                    myDate1 = new Date( items.deadline *1000);
                    detailobject["deadline"] = formatDateDigit(myDate1)
                }
                else
                {
                    myDate1 = ""
                    detailobject["deadline"] = ""
                }
    
                if(items.completedate != undefined)
                {
                    myDate2 = new Date( items.completedate *1000);
                    detailobject["completedate"] = formatDateDigit(myDate2)
                }
                else
                {
                    myDate2 = ""
                    detailobject["completedate"] = ""
                }
                
                var myDate2 = new Date( items.completedate *1000);
                detailobject["createdte"] = formatDateDigit(myDate)
    
                
                detaillist.push(detailobject)
                obj["detaillist"] = detaillist
                detailobject={}
                
                
              
               if(count == xData.length)
               {
                   newlist.push(obj)
               }
            
    
            }
            count++
            if(count == xData.length)
            {
                newlist.push(obj)
            }
      
        });
        
        return newlist;
    }


    function handleDateRange(dateString, xType) {
        

        console.log(dateString.format("YYYY/MM/DD"))
        const startOfMonth = dateString.startOf('month').format('YYYY/MM/DD');
        const endOfMonth   = dateString.endOf('month').format('YYYY/MM/DD');
        setDateRange({
            from: startOfMonth,
            to: endOfMonth
        })
        console.log(startOfMonth)
        console.log(endOfMonth)

       // doGetTaskAPI()
        // console.log('dateString',dateString)
       // if (xType === 'from') {
       //     setDateRange({
       //         from: dateString,
       //         to: dateString
       //     })
       // }
        //else if (xType === 'to') {
        //    setDateRange({
        //        from: dateRange.from,
        //        to: dateString
        //    })
       // }
    }

    useEffect(() =>{
       doGetTaskAPI()
        
   },[])
    return (
    <>
            <Row justify="start">
                <Divider>{prop.title ?? "."}</Divider>
            </Row>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="gutter-row" offset={2}>
                    
                        <DatePicker onChange={(t) => handleDateRange(t, 'from')} value={moment(dateRange.from)} 
                        disabledDate={current => {
                            return current && current > moment();
                        }} picker="month"/>
                  
                </Col>
                <Col className="gutter-row">
                <Button onClick={doGetTaskAPI}>Search</Button>
                </Col>
        
                </Row>
                <Row>
                
                <Col span={22} offset={1} shouldUpdate={(prevVal, curVal) => prevVal !== curVal}>
                <h2>{resulttabletitle}</h2>
                    <Table
                     style={{ whiteSpace: 'break-spaces' }}
                     size={'small'}
                     columns={summarytable}
                     pagination={true}
                     dataSource={finalresult}
                     bordered = {true}
                     rowkey={(record) => record.key}
                     //title={() => 'Task Listing'}
                     expandable={{
                        expandedRowRender: asd => (
                            <Table
                                style={{ margin: '5px 5px 5px -15px' }}
                                size={'small'}
                                columns={detailtable}
                                dataSource={asd.detaillist}
                                pagination={false}
                                //showHeader={false}
                                bordered={true}
                            ></Table>)
                        ,
                        expandIconColumnIndex: -1,
                        expandRowByClick: true,
                       
                        //expandedRowClassName:ExpandClass

                    }}>
                         

                    </Table>
                    </Col>
                </Row>

                <Row>
                <Col span={22} offset={1} shouldUpdate={(prevVal, curVal) => prevVal !== curVal}>
                    <h2>{pendingresulttabletitle}</h2>
                    <Table
                     style={{ whiteSpace: 'break-spaces' }}
                     size={'small'}
                     columns={summarypendingtable}
                     pagination={true}
                     dataSource={pendingresult}
                     bordered = {true}
                     rowkey={(record) => record.key}
                     //title={() => 'Pending Listing'}
                     expandable={{
                        expandedRowRender: asd => (
                            <Table
                                style={{ margin: '5px 5px 5px -15px' }}
                                size={'small'}
                                columns={detailpendingtable}
                                dataSource={asd.detaillist}
                                pagination={false}
                                //showHeader={false}
                                bordered={true}
                            ></Table>)
                        ,
                        expandIconColumnIndex: -1,
                        expandRowByClick: true,
                       
                        //expandedRowClassName:ExpandClass

                    }}>
                         

                    </Table>
                    </Col>
                </Row>
        

        </>
    )
}